<input
  #radioElement
  [id]="identifier"
  type="radio"
  [required]="required"
  [disabled]="disabled"
  [checked]="selected"
  (change)="changed.emit($event.target.checked)"
/>
<label *ngIf="label" truncate [for]="identifier">{{ label }}</label>
